import { keyframes } from 'styled-components';
export const fadeOut = keyframes `
  0% { opacity: 1 }
  100% { opacity: 0 }
`;
export const fadeIn = keyframes `
  0% { opacity: 0 }
  100% { opacity: 1 }
`;
export const slideIn = keyframes `
  from { transform: translateX(1.75rem) }
  to { transform: translateX(0) }
`;
export const slideOut = keyframes `
  from { transform: translateX(0) }
  to { transform: translateX(1.75rem) }
`;
export const rotate = keyframes `
  from {
    transform: rotate(0)
  }

  to {
    transform: rotate(450deg);
  }
`;
export const rotate360 = keyframes `
  from {
    transform: rotate(0)
  }

  to {
    transform: rotate(360deg);
  }
`;
export const line = keyframes `
  0% {
    stroke-dasharray: 2, 85.964;
    transform: rotate(0);
  }

  50% {
    stroke-dasharray: 65.973, 21.9911;
    stroke-dashoffset: 0;
  }

  100% {
    stroke-dasharray: 2, 85.964;
    stroke-dashoffset: -65.973;
    transform: rotate(90deg);
  }
`;
export const zoomIn = keyframes `
  0% { transform: scale(0); }
  100% { transform: scale(1); }
`;
export const zoomOut = keyframes `
  0% { transform: scale(1); }
  100% { transform: scale(0); }
`;
//# sourceMappingURL=index.js.map